import driverService from '../services/driverService';

export const DRIVER_CLOCKED_IN_STATE_CHANGE = '@drivers/state-change';
export const DRIVERS_CLOCKED_IN_STATE_CHANGE = '@drivers/drivers-state-change';
export const DRIVERS_COLLECTED = '@drivers/drivers-collected';

export function getDrivers() {
  return async (dispatch) => {
    try {
      const drivers = await driverService.getDrivers();

      dispatch({
        type: DRIVERS_COLLECTED,
        payload: {
          drivers
        }
      });
    } catch (error) {
      throw error;
    }
  };
}

export function updateDriver(driver) {
  return async (dispatch) => {
    dispatch({
      type: DRIVER_CLOCKED_IN_STATE_CHANGE,
      payload: {
        driver
      }
    });
  };
}

export function updateDrivers(drivers) {
  return async (dispatch) => {
    dispatch({
      type: DRIVERS_CLOCKED_IN_STATE_CHANGE,
      payload: {
        drivers
      }
    });
  };
}
